import type { Resource } from '../../';
export const product_sizeChart_measurements_uk: Resource = {"default":"UK"};
